<template>
  <div :class="[name]">
    <a-heading :cms="cms" :class="`${name}__heading`" />
    <div :class="`${name}__summary`">
      <a-eyebrow :cms="cms" :class="`${name}__eyebrow`" />
      <div :class="`${name}__selection`">{{ checkedItems.join(', ') }}</div>
      <a-cta-v2
        v-if="checkedItems.length > 0"
        :cms="{ icon: 'icon-close' }"
        :class="`${name}__clear`"
        @click.native="checkedItems = []"
      />
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="cms.copy"
      :class="`${name}__text`"
      v-html="$options.filters.markdown(cms.copy)"
    />
    <!--eslint-enable-->
    <component
      :is="item.component"
      v-for="item in cms.cta"
      :key="item._uid"
      v-editable="item"
      :cms="item"
      type="secondary"
      :class="`${name}__cta`"
    />
    <ul :class="[`${name}__options`]">
      <li
        v-for="(item, index) in filters"
        :key="index"
        :class="[`${name}__option`]"
      >
        <input
          :id="item.value"
          v-model="checkedItems"
          type="checkbox"
          :class="[`${name}__checkbox`]"
          :value="item.value"
          :name="item.value"
        />
        <span :class="[`${name}__toggle`]"></span>
        <label :for="item.value" :class="[`${name}__name`]">
          {{ item.name }}
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import data from '@/components/molecules/m-filters/m-filter-latest.data'
import Colors from '~/mixins/colors'
import ACtaV2 from '~/components/atoms/a-ctas/a-cta-v2'

export default {
  components: { ACtaV2 },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'm-filter-latest',
      checkedItems: [],
    }
  },

  computed: {
    ...mapGetters({
      filters: 'filters/getLatestFilter',
    }),
    spacing() {
      return this.cms.spacing
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#FFFFFF',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#000000'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
      }
    },
  },
  watch: {
    checkedItems(newValue) {
      this.$emit('onLatestFilterClick', this.checkedItems)
    },
  },
  async beforeCreate() {
    await this.$store.dispatch('filters/latestFilter')
  },
  methods: {
    onLatestFilterClick() {
      this.$emit('onLatestFilterClick', this.checkedItems)
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-filter-latest {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  padding: 0 0 43px;

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  &__heading {
    @include font-family($font-family-headings, 600);
    @include font-size(16, 28px);
  }
  &__eyebrow {
    margin: 0;
    @include font-size(16, 28px);
  }
  &__summary {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    padding: 5px 0 40px;
    border-bottom: 1px solid $swirl;
  }
  &__selection {
    justify-self: center;
  }
  &__clear {
    justify-self: end;
    text-align: right;
  }
  &__options {
    list-style: none;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 0;
    margin: 42px 0;
  }
  &__toggle {
    width: 10px;
    height: 10px;
    display: inline-block;
    margin-right: 5px;
    margin-left: -20px;
    border: 1px solid var(--text-color);
    border-radius: 2px;
  }
  &__checkbox:checked ~ &__toggle {
    background-color: var(--text-color);
  }
  &__name {
    @include font-size(14, 24px);
  }
  &__checkbox {
    width: 10px;
    vertical-align: middle;
    margin-right: 5px;
  }
}

@include media-breakpoint-up(md) {
  .m-filter-latest {
    &__options {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}

@include media-breakpoint-up(lg) {
  .m-filter-latest {
    &__options {
      grid-template-columns: repeat(5, 1fr);
    }
  }
}
</style>
